"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.securityReducer = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _utils = require("@alycecom/utils");

var _security = require("./security.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  forceSso: true,
  allowedDomains: [],
  dashboardAccess: false,
  revenueImpactDashboardAccess: false,
  revenueImpactDashboardCreatedPipeline: false,
  numberOfDaysBeforeOpportunityIsCreated: 0,
  status: _utils.StateStatus.Idle
};
exports.initialState = initialState;
var securityReducer = (0, _reduxAct.createReducer)({}, initialState).on(_security.toggleForceSsoRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    forceSso: !state.forceSso
  });
}).on(_security.toggleForceSsoFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    forceSso: !state.forceSso
  });
}).on(_security.toggleForceSsoSuccess, function (state, forceSso) {
  return _objectSpread(_objectSpread({}, state), {}, {
    forceSso
  });
}).on(_security.updateDomainsRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Pending
  });
}).on(_security.updateDomainsFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Rejected
  });
}).on(_security.updateDomainsSuccess, function (state, allowedDomains) {
  return _objectSpread(_objectSpread({}, state), {}, {
    allowedDomains,
    status: _utils.StateStatus.Fulfilled
  });
}).on(_security.updateDashboardAccess.pending, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Pending
  });
}).on(_security.updateDashboardAccess.fulfilled, function (state, _ref) {
  var enabled = _ref.enabled;
  return _objectSpread(_objectSpread({}, state), {}, {
    dashboardAccess: enabled,
    status: _utils.StateStatus.Fulfilled
  });
}).on(_security.updateDashboardAccess.rejected, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Rejected
  });
}).on(_security.updateRevenueImpactDashboardAccess.pending, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Pending
  });
}).on(_security.updateRevenueImpactDashboardAccess.fulfilled, function (state, _ref2) {
  var enabled = _ref2.enabled;
  return _objectSpread(_objectSpread({}, state), {}, {
    revenueImpactDashboardAccess: enabled,
    status: _utils.StateStatus.Fulfilled
  });
}).on(_security.updateRevenueImpactDashboardAccess.rejected, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Rejected
  });
}).on(_security.updateRevenueImpactDashboardCreatedPipeline.pending, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Pending
  });
}).on(_security.updateRevenueImpactDashboardCreatedPipeline.fulfilled, function (state, _ref3) {
  var enabled = _ref3.enabled,
      numberOfDaysBeforeOpportunityIsCreated = _ref3.numberOfDaysBeforeOpportunityIsCreated;
  return _objectSpread(_objectSpread({}, state), {}, {
    revenueImpactDashboardCreatedPipeline: enabled,
    numberOfDaysBeforeOpportunityIsCreated,
    status: _utils.StateStatus.Fulfilled
  });
}).on(_security.updateRevenueImpactDashboardCreatedPipeline.rejected, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    status: _utils.StateStatus.Rejected
  });
}).on(_security.securityLoadSuccess, function (state, securitySettingsResponse) {
  var _securitySettingsResp = securitySettingsResponse.data,
      forceSSO = _securitySettingsResp.forceSSO,
      allowedDomains = _securitySettingsResp.allowedDomains,
      dashboardAccess = _securitySettingsResp.dashboardAccess,
      revenueImpactDashboardAccess = _securitySettingsResp.revenueImpactDashboardAccess,
      revenueImpactDashboardCreatedPipeline = _securitySettingsResp.revenueImpactDashboardCreatedPipeline;
  var securitySettings = {
    forceSso: forceSSO.enabled,
    allowedDomains: allowedDomains || [],
    dashboardAccess: dashboardAccess.enabled,
    revenueImpactDashboardAccess: revenueImpactDashboardAccess.enabled,
    revenueImpactDashboardCreatedPipeline: revenueImpactDashboardCreatedPipeline === null || revenueImpactDashboardCreatedPipeline === void 0 ? void 0 : revenueImpactDashboardCreatedPipeline.enabled,
    numberOfDaysBeforeOpportunityIsCreated: revenueImpactDashboardCreatedPipeline === null || revenueImpactDashboardCreatedPipeline === void 0 ? void 0 : revenueImpactDashboardCreatedPipeline.numberOfDaysBeforeOpportunityIsCreated,
    status: _utils.StateStatus.Fulfilled
  };
  return _objectSpread(_objectSpread({}, state), securitySettings);
});
exports.securityReducer = securityReducer;